// hooks/useModuleData.js
import { useState, useEffect, useCallback } from "react";
import { getModuleById, getCompleteClientInfo } from "../api";

export function useModuleData(brand, language, moduleId) {
    const [module, setModule] = useState({});
    const [clientData, setClientData] = useState(null);
    const [languageData, setLanguageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const { clientData, languageData } = await getCompleteClientInfo(
                brand,
                language
            );
            const moduleData = await getModuleById(moduleId);

            setClientData(clientData);
            setLanguageData(languageData);
            setModule(moduleData);
        } catch (err) {
            console.error("Erreur lors de la récupération des données:", err);
            setError(err);
        } finally {
            setLoading(false);
        }
    }, [brand, language, moduleId]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return { module, clientData, languageData, loading, error };
}
